import React, { useEffect, useState } from 'react';
import './answerDetail.style.scss';
import { Answer, AnswerStatus, Question, QuestionTypes, ReduxState } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { RoutePath } from 'data';
import { Link } from 'react-router-dom';
import { __AnswerDetailProps } from './answerDetail.interface';
import { answerItemNodeGenerator } from './data.comp';
import { getDBAnswer } from 'scripts/db';
import { extractTitle } from 'scripts/string';

const AnswerDetail: React.FC<__AnswerDetailProps & ConnectedProps<typeof connector>> = function (
    props: __AnswerDetailProps & ConnectedProps<typeof connector>,
) {
    const lang = props.lang.answerDetail;
    const { publish, form, answer } = useParams<any>();
    const history = useHistory();
    const [answerDetail, setAnswerDetail] = useState<Answer>();
    const time = answerDetail
        ? answerDetail.modified_at
            ? new Date(answerDetail.modified_at).toLocaleDateString('fa')
            : new Date(answerDetail.created_at).toLocaleDateString('fa')
        : '';
    const questions: Question[] = [];
    const parents: { parent: Question; children: Question[] }[] = [];
    props.publish?.form.sections.map((sec) =>
        sec.questions.map((que) => {
            if (que.children?.length) parents.push({ parent: que, children: que.children });
        }),
    );
    answerDetail?.items?.map((item) => {
        if (item.question) {
            if (![QuestionTypes.priority, QuestionTypes.matrix].includes(item.question.input_type))
                questions.push({ ...item.question });
            else {
                const parent = parents.find((parent) => parent.children.map((i) => i.id).includes(item.question.id));
                if (item.question.input_type === QuestionTypes.matrix) {
                    if (parent)
                        questions.push({
                            ...parent.parent,
                            children: [item.question],
                        });
                } else if (item.question.input_type === QuestionTypes.priority) {
                    if (parent && !questions.map((i) => i.id).includes(parent.parent.id))
                        questions.push({ ...parent.parent });
                }
            }
        }
    });

    useEffect(() => {
        getDBAnswer(Number(answer)).then((res) => {
            if (res) setAnswerDetail(res);
        });
    }, []);

    useEffect(() => {
        if (props.goback) {
            props.setGoback();
            history.replace(RoutePath.dashboard.answerList(publish, form));
        }
    }, [props.goback]);

    return (
        <div className="ucheck-kiosk-answer-detail-page">
            <div className="content">
                <h3>{lang.answerDetail + ' ' + answer}</h3>

                <div className="subtitle">
                    <div
                        className={`status ${
                            answerDetail ? (answerDetail.state !== AnswerStatus.incomplete ? 'active' : '') : 'not-load'
                        }`}
                    >
                        <i className="material-icons-outlined">
                            {answerDetail?.state !== AnswerStatus.incomplete ? 'check_circle_outline' : 'cancel'}
                        </i>
                        <span className={`${answerDetail ? '' : 'ucheck-skeleton'}`}>
                            {answerDetail
                                ? answerDetail.state !== AnswerStatus.incomplete
                                    ? lang.statuses.complete
                                    : lang.statuses.incomplete
                                : ''}
                        </span>
                        {answerDetail &&
                            answerDetail.state === AnswerStatus.incomplete &&
                            answerDetail.questionerOffline && (
                                <Link to={RoutePath.dashboard.answerEdit(publish, form, answer)}>
                                    {/* {answerDetail.state === AnswerStatus.complete ? lang.edit : lang.complete} */}
                                    {lang.complete}
                                </Link>
                            )}
                    </div>
                    <div className="time">
                        <i className="material-icons-outlined">schedule</i>
                        <span className={`${answerDetail ? '' : 'ucheck-skeleton'}`}>{time}</span>
                    </div>
                </div>
                <div className="answers">
                    {answerDetail ? (
                        answerDetail.items?.length ? (
                            <>
                                {questions?.map((item, index) => (
                                    <div className="item" key={index}>
                                        <div className="question">
                                            {extractTitle(item.title)}
                                            {item.input_type === QuestionTypes.matrix &&
                                            item.children &&
                                            item.children.length
                                                ? ' : ' + item.children[0].title
                                                : ''}
                                        </div>
                                        <div key={index} className="answer">
                                            <span>{item && answerItemNodeGenerator([item], answerDetail?.items)}</span>
                                        </div>
                                    </div>
                                ))}
                            </>
                        ) : (
                            <p className="empty-item-text">{lang.noItems}</p>
                        )
                    ) : (
                        Array.from(Array(10).keys()).map((item, index) => (
                            <div className="item skeleton-item" key={index}>
                                <div
                                    className="question ucheck-skeleton"
                                    style={{ width: (32 + Math.random() * 32).toString() + '%' }}
                                />
                                <div
                                    key={index}
                                    className="answer ucheck-skeleton"
                                    style={{ width: (24 + Math.random() * 56).toString() + '%' }}
                                />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    dir: state.direction,
    lang: state.lang,
    publish: state.publishData,
});

const connector = connect(mapStateToProps);
export default connector(AnswerDetail);
